import { render, staticRenderFns } from "./ModalAddCustomDomain.vue?vue&type=template&id=cd8617f6&scoped=true"
import script from "./ModalAddCustomDomain.vue?vue&type=script&lang=js"
export * from "./ModalAddCustomDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8617f6",
  null
  
)

export default component.exports